export const ELIGIBLE_MODELS_FOR_BUYER_MODEL_PER_PAGE = 10;
